// Brand Color Theme
// Strict color palette - use ONLY these colors throughout the application

export const COLORS = {
  // Primary Colors
  MIDNIGHT: '#395157',    // Footer only
  AUTUMN: '#d45614',      // Buttons and CTAs
  LINEN: '#f4ece5',       // Backgrounds

  // Shades for hover/active states
  AUTUMN_DARK: '#a8430e',     // Darker autumn for hover
  AUTUMN_LIGHT: '#e67d47',    // Lighter autumn for subtle elements
  MIDNIGHT_LIGHT: '#4a6670',  // Lighter midnight if needed

  // Neutral colors for text (when needed)
  TEXT_DARK: '#2d2d2d',
  TEXT_MUTED: '#666666',
  WHITE: '#ffffff',
  BLACK: '#000000',
};

// Helper to get color with optional opacity
export const withOpacity = (color, opacity) => {
  // Convert hex to rgba
  const hex = color.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export default COLORS;
